import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B10_FORM_INITIAL_VALUES } from './constants'
import RadioInput from '../../../../../../../components/inputs/RadioInput'

interface Props {}

export const B10ConstructionOrganizationTermsForm: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<typeof B10_FORM_INITIAL_VALUES>
  return (
    <>
      <FormSectionTwoColumns
        sectionKey="b10.traficAndtechnicalInfrastructureConnection"
        title="a) napojení staveniště na stávající dopravní a technickou infrastrukturu"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.traficAndtechnicalInfrastructureConnection.waterSupply.enabled"
            component={CheckboxInput}
            label="Zásobování vodou"
          />
          {formik.values.b10.traficAndtechnicalInfrastructureConnection.waterSupply.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.traficAndtechnicalInfrastructureConnection.waterSupply.description"
                component={RichTextInput}
                aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu - Zásobování vodou"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.traficAndtechnicalInfrastructureConnection.electricity.enabled"
            component={CheckboxInput}
            label="Zásobování el. energií"
          />
          {formik.values.b10.traficAndtechnicalInfrastructureConnection.electricity.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.traficAndtechnicalInfrastructureConnection.electricity.description"
                component={RichTextInput}
                aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu - Zásobování el. energií"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.traficAndtechnicalInfrastructureConnection.sewageAndRainWater.enabled"
            component={CheckboxInput}
            label="Splaškové a dešťové vody"
          />
          {formik.values.b10.traficAndtechnicalInfrastructureConnection.sewageAndRainWater
            .enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.traficAndtechnicalInfrastructureConnection.sewageAndRainWater.description"
                component={RichTextInput}
                aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu - Splaškové a dešťové vody"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.traficAndtechnicalInfrastructureConnection.traffic.enabled"
            component={CheckboxInput}
            label="Doprava"
          />
          {formik.values.b10.traficAndtechnicalInfrastructureConnection.traffic.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.traficAndtechnicalInfrastructureConnection.traffic.description"
                component={RichTextInput}
                aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu - Doprava"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.traficAndtechnicalInfrastructureConnection.other.enabled"
            component={CheckboxInput}
            label="Vlastní"
          />
          {formik.values.b10.traficAndtechnicalInfrastructureConnection.other.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.traficAndtechnicalInfrastructureConnection.other.description"
                component={RichTextInput}
                aiHint="Napojení staveniště na stávající dopravní a technickou infrastrukturu - Vlastní"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.protectionOfSurroundings"
        title="b) ochrana okolí staveniště a požadavky na související asanace, demolice, demontáž, dekonstrukce a kácení dřevin apod"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.constructionSurroundingsProtection.enabled"
            component={CheckboxInput}
            label="Ochrana okolí staveniště"
          />
          {formik.values.b10.protectionOfSurroundings.constructionSurroundingsProtection
            .enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.constructionSurroundingsProtection.description"
                component={RichTextInput}
                aiHint="Ochrana okolí staveniště"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.urbanRenewal.enabled"
            component={CheckboxInput}
            label="Asanace"
          />
          {formik.values.b10.protectionOfSurroundings.urbanRenewal.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.urbanRenewal.description"
                component={RichTextInput}
                aiHint="Asanace"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.demolition.enabled"
            component={CheckboxInput}
            label="Demolice"
          />
          {formik.values.b10.protectionOfSurroundings.demolition.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.demolition.description"
                component={RichTextInput}
                aiHint="Demolice"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.disassembly.enabled"
            component={CheckboxInput}
            label="Demontáž"
          />
          {formik.values.b10.protectionOfSurroundings.disassembly.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.disassembly.description"
                component={RichTextInput}
                aiHint="Demontáž"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.deconstruction.enabled"
            component={CheckboxInput}
            label="Dekonstrukce"
          />
          {formik.values.b10.protectionOfSurroundings.deconstruction.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.deconstruction.description"
                component={RichTextInput}
                aiHint="Dekonstrukce"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.treeFelling.enabled"
            component={CheckboxInput}
            label="Kácení dřevin"
          />
          {formik.values.b10.protectionOfSurroundings.treeFelling.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.treeFelling.description"
                component={RichTextInput}
                aiHint="Kácení dřevin"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.protectionOfSurroundings.other.enabled"
            component={CheckboxInput}
            label="Vlastní"
          />
          {formik.values.b10.protectionOfSurroundings.other.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.protectionOfSurroundings.other.description"
                component={RichTextInput}
                aiHint="b) ochrana okolí staveniště a požadavky na související asanace, demolice, demontáž, dekonstrukce a kácení dřevin apod - Vlastní"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.constructionEntrance"
        title="c) vstup a vjezd na stavbu, přístup na stavbu po dobu výstavby, popřípadě přístupové trasy, včetně požadavků na obchozí trasy pro osoby s omezenou schopností pohybu nebo
orientace a způsob zajištění bezpečnosti provozu"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.constructionEntrance.description"
            component={RichTextInput}
            aiHint="c) vstup a vjezd na stavbu, přístup na stavbu po dobu výstavby, popřípadě přístupové trasy, včetně požadavků na obchozí trasy pro osoby s omezenou schopností pohybu nebo
orientace a způsob zajištění bezpečnosti provozu"
          />
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.constructionEntrance"
        title="d) maximální dočasné a trvalé zábory pro staveniště"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.maximumLandOccupation.enabled"
            component={RadioInput}
            options={[
              { value: true, label: 'Ano' },
              { value: false, label: 'Ne' },
            ]}
            label="Zábory:"
          />
          {formik.values.b10.maximumLandOccupation.enabled && (
            <div className="pl-7 mt-3">
              <div className="sm:col-span-6 mt-4">
                <Field
                  name="b10.maximumLandOccupation.permanent.enabled"
                  component={CheckboxInput}
                  label="Trvalé"
                />
                {formik.values.b10.maximumLandOccupation.permanent.enabled && (
                  <div className="pl-7 mt-3">
                    <Field
                      name="b10.maximumLandOccupation.permanent.description"
                      component={RichTextInput}
                      aiHint="maximální dočasné a trvalé zábory pro staveniště - Zábory - Trvalé"
                    />
                  </div>
                )}
              </div>
              <div className="sm:col-span-6 mt-4">
                <Field
                  name="b10.maximumLandOccupation.temporary.enabled"
                  component={CheckboxInput}
                  label="Dočasné"
                />
                {formik.values.b10.maximumLandOccupation.temporary.enabled && (
                  <div className="pl-7 mt-3">
                    <Field
                      name="b10.maximumLandOccupation.temporary.description"
                      component={RichTextInput}
                      aiHint="maximální dočasné a trvalé zábory pro staveniště - Zábory - Dočasné"
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.environmentProtection"
        title="e) požadavky na ochranu životního prostředí při výstavbě - zejména opatření k minimalizaci dopadů při provádění stavby na životní prostředí, popis přítomnosti nebezpečných látek
při výstavbě, předcházení vzniku odpadů, třídění materiálů pro recyklaci za účelem materiálového využití, včetně popisu opatření proti kontaminaci materiálů, stavby a jejího okolí,
opatření při nakládání s azbestem, opatření na snížení hluku ze stavební činnosti a opatření proti prašnosti"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.environmentProtection.description"
            component={RichTextInput}
            aiHint="e) požadavky na ochranu životního prostředí při výstavbě - zejména opatření k minimalizaci dopadů při provádění stavby na životní prostředí, popis přítomnosti nebezpečných látek
při výstavbě, předcházení vzniku odpadů, třídění materiálů pro recyklaci za účelem materiálového využití, včetně popisu opatření proti kontaminaci materiálů, stavby a jejího okolí,
opatření při nakládání s azbestem, opatření na snížení hluku ze stavební činnosti a opatření proti prašnosti"
          />
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.OHS"
        title="f) zásady bezpečnosti a ochrany zdraví při práci na staveništi"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.OHS.description"
            component={RichTextInput}
            aiHint="f) zásady bezpečnosti a ochrany zdraví při práci na staveništi"
          />
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.earthWorks"
        title="g) bilance zemních prací, požadavky na přísun nebo deponie zemin"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.earthWorks.earthWorksBalance.enabled"
            component={CheckboxInput}
            label="Bilance zemních prací"
          />
          {formik.values.b10.earthWorks.earthWorksBalance.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.earthWorks.earthWorksBalance.description"
                component={RichTextInput}
                aiHint="Bilance zemních prací"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.earthWorks.soilDelivery.enabled"
            component={CheckboxInput}
            label="Požadavky na přísun zemin"
          />
          {formik.values.b10.earthWorks.soilDelivery.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.earthWorks.soilDelivery.description"
                component={RichTextInput}
                aiHint="Požadavky na přísun zemin"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.earthWorks.storageArea.enabled"
            component={CheckboxInput}
            label="Požadavky na deponie zemin"
          />
          {formik.values.b10.earthWorks.storageArea.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.earthWorks.storageArea.description"
                component={RichTextInput}
                aiHint="Požadavky na deponie zemin"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.heightMachineryLimits"
        title="h) limity pro užití výškové mechanizace"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.heightMachineryLimits.enabled"
            component={CheckboxInput}
            label="Nejsou určeny"
          />
          {!formik.values.b10.heightMachineryLimits.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.heightMachineryLimits.description"
                component={RichTextInput}
                aiHint="limity pro užití výškové mechanizace"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.requirements"
        title="i) požadavky na postupné uvádění stavby do provozu (užívání), požadavky na průběh a způsob přípravy a realizace výstavby a další specifické požadavky"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.requirements.gradualCommissioning.enabled"
            component={CheckboxInput}
            label="Postupné uvádění stavby do provozu"
          />
          {formik.values.b10.requirements.gradualCommissioning.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.requirements.gradualCommissioning.description"
                component={RichTextInput}
                aiHint="Postupné uvádění stavby do provozu"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.requirements.processAndMethodOfConstruction.enabled"
            component={CheckboxInput}
            label="Požadavky na průběh a způsob přípravy a realizace výstavby"
          />
          {formik.values.b10.requirements.processAndMethodOfConstruction.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.requirements.processAndMethodOfConstruction.description"
                component={RichTextInput}
                aiHint="Požadavky na průběh a způsob přípravy a realizace výstavby"
              />
            </div>
          )}
        </div>
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.requirements.other.enabled"
            component={CheckboxInput}
            label="Další specifické požadavky"
          />
          {formik.values.b10.requirements.other.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.requirements.other.description"
                component={RichTextInput}
                aiHint="Požadavky na postupné uvádění stavby do provozu (užívání), požadavky na průběh a způsob přípravy a realizace výstavby a další specifické požadavky - Další specifické požadavky"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b10.constructionPhases"
        title="j) návrh fází výstavby za účelem provedení kontrolních prohlídek"
      >
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.constructionPhases.enabled"
            component={RadioInput}
            options={[
              { value: true, label: 'Ano' },
              { value: false, label: 'Ne' },
            ]}
            label="Je výstavba dělena na fáze?"
          />
          {formik.values.b10.constructionPhases.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.constructionPhases.description"
                component={RichTextInput}
                aiHint="Návrh fází výstavby za účelem provedení kontrolních prohlídek - výstavba dělená na fáze - popis"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns sectionKey="b10.temporaryObjects" title="k) dočasné objekty">
        <div className="sm:col-span-6 mt-4">
          <Field
            name="b10.temporaryObjects.enabled"
            component={RadioInput}
            options={[
              { value: true, label: 'Ano' },
              { value: false, label: 'Ne' },
            ]}
          />
          {formik.values.b10.temporaryObjects.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b10.temporaryObjects.description"
                component={RichTextInput}
                aiHint="k) dočasné objekty - Ano - Popis"
              />
            </div>
          )}
        </div>
      </FormSectionTwoColumns>
    </>
  )
}
